export default __webpack_public_path__ + "static/media/whiteAzure.d8d89f8f.svg";